module.exports = __webpack_public_path__ + "static/smiling-office-worker-desktop.8abb04e9.webp";